const REST_BUCKET = 'REST';

export const bucketNameSorter = (a, b) => {
  if (typeof a !== 'string' || typeof b !== 'string') {
    return 0;
  }
  // eslint-disable-next-line no-useless-escape
  if (/\</g.test(a) && /\</g.test(b)) {
    const [, num1] = a.split('<');
    const [, num2] = b.split('<');
    return parseFloat(num1) - parseFloat(num2);
  }
  // eslint-disable-next-line no-useless-escape
  if (/\</g.test(a)) {
    return -1;
  }
  // eslint-disable-next-line no-useless-escape
  if (/\</g.test(b)) {
    return -1;
  }
  const [num1] = a.split('-');
  const [num2] = b.split('-');
  return parseFloat(num1) - parseFloat(num2);
};

export default (response, distributionMetric) => (response && distributionMetric)
  ? response.map(
    (row) => row[distributionMetric.dimension]
  ).sort(bucketNameSorter).filter(bucket => bucket && bucket !== REST_BUCKET) : [];
